export default "__VITE_ASSET__wdNcGcFk__ 720w";